import { Link } from "react-router";
import { Phone, Mail, Clock } from "lucide-react";
import { Logo } from "../ui/Logo";
import { NAV, SERVICES, SITE, CONTACT, CREDENTIALS, SERVICE_AREA } from "../../lib/site";

export function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-line bg-surface-2">
      <div className="mx-auto grid w-full max-w-6xl gap-10 px-5 py-14 sm:px-8 md:grid-cols-[1.4fr_1fr_1fr]">
        <div>
          <Link
            to="/"
            className="inline-flex items-center gap-2.5 rounded-lg focus-visible:outline-2 focus-visible:outline-offset-4"
            aria-label={`${SITE.name} — home`}
          >
            <Logo className="h-9" />
            <span className="font-display text-lg font-semibold tracking-tight text-ink">
              {SITE.name}
            </span>
          </Link>
          <p className="mt-4 max-w-xs text-sm text-ink-soft">
            Licensed, insured electrical contractor serving the Raleigh–Durham Triangle.
          </p>
          <ul className="mt-5 flex flex-col gap-2 text-sm">
            <li>
              <a
                href={`tel:${CONTACT.phoneTel}`}
                className="inline-flex items-center gap-2 text-ink transition hover:text-accent-strong"
              >
                <Phone className="size-4 text-accent-strong" aria-hidden="true" />
                {CONTACT.phoneDisplay}
              </a>
            </li>
            <li>
              <a
                href={`mailto:${CONTACT.email}`}
                className="inline-flex items-center gap-2 text-ink transition hover:text-accent-strong"
              >
                <Mail className="size-4 text-accent-strong" aria-hidden="true" />
                {CONTACT.email}
              </a>
            </li>
            <li className="inline-flex items-center gap-2 text-ink-soft">
              <Clock className="size-4 text-accent-strong" aria-hidden="true" />
              {CONTACT.hoursShort}
            </li>
          </ul>
        </div>

        <nav aria-label="Footer">
          <h2 className="eyebrow mb-3">Explore</h2>
          <ul className="flex flex-col gap-2 text-sm">
            {NAV.map((item) => (
              <li key={item.href}>
                <Link to={item.href} className="text-ink-soft transition hover:text-ink">
                  {item.label}
                </Link>
              </li>
            ))}
            <li>
              <Link to="/privacy" className="text-ink-soft transition hover:text-ink">
                Privacy
              </Link>
            </li>
          </ul>
        </nav>

        <nav aria-label="Services">
          <h2 className="eyebrow mb-3">Services</h2>
          <ul className="flex flex-col gap-2 text-sm">
            {SERVICES.slice(0, 6).map((s) => (
              <li key={s.id}>
                <Link to={`/services#${s.id}`} className="text-ink-soft transition hover:text-ink">
                  {s.title}
                </Link>
              </li>
            ))}
          </ul>
        </nav>
      </div>

      <div className="border-t border-line">
        <div className="mx-auto flex w-full max-w-6xl flex-col gap-2 px-5 py-6 text-sm text-ink-soft sm:flex-row sm:items-center sm:justify-between sm:px-8">
          <p>
            © {year} {SITE.legalName}. All rights reserved.
          </p>
          <p className="font-mono text-xs">
            {CREDENTIALS.licenseText} · Serving {SERVICE_AREA.counties.join(", ")} counties
          </p>
        </div>
      </div>
    </footer>
  );
}
